const FoodBar: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M15.8333 1.66663V4.16663H17.5V1.66663H15.8333ZM12.5 2.49996V4.16663H14.1667V2.49996H12.5ZM9.16667 5.83329C8.6375 5.83329 8.12454 5.95863 7.65788 6.20113C6.54121 5.57696 5.06135 5.80334 4.17969 6.69918C2.42969 6.43168 0.833333 7.83163 0.833333 9.58329C0.833333 9.72704 0.862396 9.86242 0.883789 9.99996H0V10.8333C0 13.1341 1.86583 15 4.16667 15H10.4492C10.0184 14.52 9.68781 13.9525 9.46615 13.3333H4.16667C3.08 13.3333 2.15406 12.6366 1.8099 11.6666H7.5H9.16667V9.99996H2.5765C2.52991 9.86914 2.5 9.72988 2.5 9.58329C2.5 8.74829 3.31604 8.08122 4.19271 8.41956L4.83073 8.66532L5.19531 8.08752C5.42781 7.72002 5.8225 7.49996 6.25 7.49996C6.63583 7.49996 6.91262 7.67715 7.07845 7.82548L7.59928 8.29097L8.14941 7.86129C8.35858 7.69629 8.70583 7.49996 9.16667 7.49996V5.83329ZM10.8333 5.83329V11.6666C10.8333 13.4971 12.3362 15 14.1667 15H15.8333C17.6638 15 19.1667 13.4971 19.1667 11.6666V5.83329H18.3333H10.8333ZM12.5 7.49996H17.5V11.6666C17.5 12.5929 16.7596 13.3333 15.8333 13.3333H14.1667C13.2404 13.3333 12.5 12.5929 12.5 11.6666V7.49996ZM0 16.6666V18.3333H20V16.6666H0Z"
      />
    </svg>
  );
};

export default FoodBar;
